import React, { PureComponent } from 'react';
import Waypoint from 'react-waypoint';

export default class StaggerIn extends PureComponent {

  constructor() {
    super();
    this.stagger = React.createRef();
  }

  componentDidMount() {
    this.staggerTl = new TimelineMax({
      paused: true,
    });

    const fade = this.stagger.current.querySelectorAll('.js-stagger');

    if (fade) {
      this.staggerTl
        .staggerFromTo(
          fade,
          0.7,
          {
            y: 30,
          },
          {
            opacity: 1,
            y: 0,
            stagger: { amount: 0.2 },
            ease: Back.easeOut.config(2.5),
          },
        );
    }
  }

  animateStagger = () => {
    if (this.staggerTl) {
      this.staggerTl.play();
    }
  }

  componentWillUnmount() {
    if (this.staggerTl) {
      this.staggerTl.kill();
    }
  }

  render() {
    return (
      <Waypoint
        onEnter={this.animateStagger}
        bottomOffset={160}
      >
        <div ref={this.stagger}>
          {this.props.children}
        </div>
      </Waypoint>
    );
  }
}

